export const BASE_PATH = '/v3';
